export default "__VITE_ASSET__d7a61f27__"